const snacksNoticePopUpTranslations = {
  title: "Notice for",
  description:
    "This is all your snacks, you have to eat them all during your day",
  actionButton: "Cancel",
};

export default snacksNoticePopUpTranslations;
